import React from 'react';

interface SkeletonProps {
  className?: string;
  width?: string;
  height?: string;
  circle?: boolean;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  className = '',
  width,
  height,
  circle = false,
}) => {
  return (
    <div
      style={{ width, height }}
      className={`animate-pulse bg-slate-200/80 backdrop-blur-sm ${
        circle ? 'rounded-full' : 'rounded-xl'
      } ${className}`}
    />
  );
};

export const CardSkeleton: React.FC = () => {
  return (
    <div className="bg-white p-6 rounded-3xl border border-slate-200 shadow-sm space-y-4 animate-pulse">
      <div className="flex items-center justify-between">
        <Skeleton className="h-5 w-36" />
        <Skeleton className="h-4 w-14 rounded-full" />
      </div>
      <Skeleton className="h-3.5 w-3/4" />
      <div className="p-3 bg-slate-50 rounded-xl space-y-2.5 border border-slate-100">
        <Skeleton className="h-3 w-28" />
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-3.5 w-24" />
      </div>
    </div>
  );
};

export const NoticeCardSkeleton: React.FC<{ layoutMode?: 'grid' | 'list' }> = ({ layoutMode = 'grid' }) => {
  if (layoutMode === 'list') {
    return (
      <div className="bg-white p-6 rounded-3xl border border-slate-200 shadow-sm flex flex-col md:flex-row justify-between gap-6 animate-pulse w-full">
        <div className="flex-1 space-y-4">
          <div className="flex items-center gap-2.5">
            <Skeleton className="h-4.5 w-24 rounded-full" />
            <Skeleton className="h-3 w-16" />
          </div>
          <Skeleton className="h-6 w-2/3" />
          <div className="space-y-2">
            <Skeleton className="h-3.5 w-full" />
            <Skeleton className="h-3.5 w-4/5" />
          </div>
          <div className="pt-2 flex gap-4 border-t border-slate-100">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-3 w-20" />
          </div>
        </div>
        <div className="w-full md:w-72 shrink-0 flex flex-col justify-center gap-3 pl-0 md:pl-6 md:border-l md:border-slate-100">
          <Skeleton className="h-10 w-full rounded-xl" />
          <Skeleton className="h-9 w-full rounded-xl" />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-3xl border border-slate-200 shadow-sm space-y-4 animate-pulse">
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-20 rounded-full" />
        <Skeleton className="h-3 w-24" />
      </div>
      <Skeleton className="h-6 w-3/4" />
      <div className="space-y-2">
        <Skeleton className="h-3.5 w-full" />
        <Skeleton className="h-3.5 w-5/6" />
      </div>
      <div className="pt-2 flex items-center justify-between">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-8 w-24 rounded-xl" />
      </div>
    </div>
  );
};

export const TableRowSkeleton: React.FC = () => {
  return (
    <tr className="animate-pulse border-b border-slate-100">
      <td className="p-3.5"><Skeleton className="h-4 w-20" /></td>
      <td className="p-3.5"><Skeleton className="h-4 w-24" /></td>
      <td className="p-3.5"><Skeleton className="h-4 w-48" /></td>
      <td className="p-3.5"><Skeleton className="h-4 w-28" /></td>
      <td className="p-3.5"><Skeleton className="h-4 w-16 ml-auto" /></td>
      <td className="p-3.5"><Skeleton className="h-4 w-20" /></td>
    </tr>
  );
};
